import * as z from "zod/v4";

export const getDomainWarmingReputationMetrics = {
  name: "getDomainWarmingReputationMetrics" as const,
  input: z.object({}),
  output: z.object({
    stats: z.object({
      clickRate: z.number(),
      openRate: z.number(),
      bounceRate: z.number(),
      complainRate: z.number(),
    }),
    messageDistribution: z.array(
      z.object({
        name: z.string(),
        data: z.array(z.object({ date: z.string(), value: z.number() })),
      }),
    ),
  }),
};
